var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-button py-1 px-3",class:_vm.filterButtonClass,on:{"click":_vm.mouseClick,"mouseover":_vm.mouseOver,"mouseleave":_vm.mouseLeave}},[_vm._v("\n    "+_vm._s(_vm.$t('ctas.filter'))+" "),_c('font-awesome-icon',{class:_vm.filterIconClass,attrs:{"icon":"filter"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c036a18a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/ToggleFilters.vue
// module id = cfP5
// module chunks = 0 107 108 115